// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function AttachmentFormSection__FileInputLink(props) {
  let __multiple = props.multiple;
  let onChange = props.onChange;
  let multiple = __multiple !== undefined ? __multiple : false;
  let inputEl = React.useRef(null);
  let onChangeEvt = evt => {
    onChange(evt.target.files);
    let node = inputEl.current;
    if (!(node == null)) {
      node.value = "";
      return;
    }
  };
  let onClick = evt => {
    evt.preventDefault();
    let node = inputEl.current;
    if (!(node == null)) {
      return node.click();
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("input", {
        ref: Primitive_option.some(inputEl),
        style: {
          height: "0",
          left: "-9999px",
          position: "absolute",
          visibility: "hidden",
          width: "0"
        },
        multiple: multiple,
        type: "file",
        onChange: onChangeEvt
      }),
      JsxRuntime.jsx("a", {
        children: props.children,
        href: "#select",
        onClick: onClick
      })
    ]
  });
}

let make = AttachmentFormSection__FileInputLink;

exports.make = make;
/* react Not a pure module */
